import React, { Component } from 'react';
import styles from '../../../Assets/CSS/stylesheet_UHS';
import Grid from '@material-ui/core/Grid';
import {AppBar, Tabs, Tab, FormControl, InputLabel, Select} from '@material-ui/core';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircle from '@material-ui/icons/AccountCircle';
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Auth } from 'aws-amplify';
import axios from "axios";
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import './window.css';
import Configuration from "../../../configurations";
import Loader from "../../loader";
import {Modal,Row,Col,Form} from "react-bootstrap";
import customStyle from "../../../Assets/CSS/stylesheet_UHS"
import MuiPhoneNumber from "material-ui-phone-number";
import AccordonCommon from '../../CommonScreens/AccordonCommon';
import {withStyles} from "@material-ui/core/styles";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Button from "@material-ui/core/Button";
import Sample from "../../CommonScreens/sampleTextField";
import SampleName from '../../CommonScreens/sampleTextFieldName';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import ClearIcon from '@material-ui/icons/Clear';
import Tooltip from '@material-ui/core/Tooltip';
import configurations from "../../../configurations";
import CommonMultilineText from '../../CommonScreens/commonMultilineText';
import { withRouter } from 'react-router-dom';
import { getQueryParams } from '../../authentication/utils';

const CustomButton = withStyles(
    customStyle.viewBtn
)(Button);

const NextButton = withStyles(
    customStyle.doneBtn
)(Button);


class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogged: false,
            loaderShow : false,
            association_logo : '',
            anchorEl:null,
            open:false,
            userName : '',
            profileModal : false,
            empProfileModal : false,
            fname:'',
            lname:'',
            email:'',
            phone:'',
            countryCode : '',
            desc : '',
            imageName : '',
            imagePath : '',
            agentValid : false,
            agentURL: '',
            defaultCountryCode : "",
            imageErr : '',
            rightBar: false,
            switchArray : [],
            countData: "",
            topbarData:null,
            postobj: {},
            modeList: sessionStorage.getItem("modeList") ? JSON.parse(sessionStorage.getItem("modeList")) : [],
            mode:  sessionStorage.getItem("mode") || "",
            ChannelName:localStorage.getItem("channelName")?localStorage.getItem("channelName"): sessionStorage.getItem("clientName"),
            cropModal: false,
            imageSrc: null,
            croppedImage: null,
            selectedFile: null,
            cropBox: { x: 50, y: 50, width: 200, height: 200 },
            isDragging: false,
            isResizing: false,
            resizeCorner: null,
            dragStart: { x: 0, y: 0 },
        };
    }

    componentDidMount() {
        this.setState({
            userName : sessionStorage.getItem('username')
        });
        this.getTopBarData();
        this.state.isLogged = sessionStorage.getItem('isLogged');
        let queryParams = getQueryParams();
        if(queryParams && queryParams.empid){
            this.setState({empid : queryParams.empid})
            this.getTotalEmpInfo(queryParams.empid)
        }
        let data = {
            "clientId" : this.props.clientId
        }
        axios.post(configurations.baseUrl + '/enrollment/getClient', data)
            .then(response=>{
                if(response.data.response){
                    this.setState({
                        agentURL : configurations.AGENT_BASE_URL + response.data.response.clientName + '/' + this.props.agentId
                    })  
                }
            });
            axios.get(process.env.REACT_APP_BASE_URL + '/agentlogin/getChannelListByAgentId/' + sessionStorage.getItem('parentBrokerId'))
            .then(response =>{
                this.setState({switchArray: response.data.response})
            })
        axios.get('https://ipapi.co/json/').then((response) => {
            if (response && response.data) {
                let data = response.data;
                this.setState({
                    defaultCountryCode : data.country_calling_code
                });
            }
        }).catch((error) => {
            console.log(error);
        });
        this.getClientProfile();
    }
    handleClose = () => {
        this.setState({open:false,anchorEl:null})
    };


    getTopBarData = () => {
        if(sessionStorage.getItem('USER_DATA')){


            axios.get(process.env.REACT_APP_BASE_URL + '/employer/getClientInfo/' + JSON.parse(sessionStorage.getItem('USER_DATA')).clientId).then(response => {
                sessionStorage.setItem('customerServiceNo', response.data.response.customerServiceNo);
                const typesOfClients = response.data.response.clientType?.replace("Agents,","").split(",") || ["Households"];
                     const params = new URLSearchParams(window.location.search);
                     const transformedArray = typesOfClients.map(item => ({
                        label: `Work with ${item}`
                      }));
                     sessionStorage.setItem("modeList", JSON.stringify(transformedArray))
                     const empid = params.get("empid");
                     if(localStorage.getItem("statusCd") && localStorage.getItem("statusCd") === "ACTIVE")
                     if(!this.state.mode && window.location.pathname === "/"){
                         this.setState({mode: transformedArray[0].label}, () => {
                            if(this.state.mode === "Work with Employers"){
                                window.location.href = "/manage-employers"
                            } else if (this.state.mode === "Work with Households"){
                                window.location.href = "/manage-prospects"
                            }
                         })
                     } else if (window.location.pathname === "/manage-prospects" && !empid) {
                         this.setState({mode: transformedArray[0].label})
                     } else if (window.location.pathname === "/manage-employers" || empid) {
                         this.setState({mode:  transformedArray[1].label})
                     }
             })

        }
      
    }
    getModeSelect = (value) => {
        sessionStorage.setItem("mode", value)
        if(value === "Work with Employers"){
            window.location.href = "/manage-employers" 
        } else if(value === "Work with Households") {
            window.location.href = "/manage-prospects"
        }
    }


    logoutHandler = (event) => {
        this.setState({
            loaderShow : true
        });
        Auth.signOut();
        localStorage.clear();
        sessionStorage.clear();
        localStorage.setItem('isLogged', false);
        sessionStorage.setItem('isLogged', false);
        window.location.href = '/login';
    }

    getTotalEmpInfo = (empid) => {
        axios.get(configurations.baseUrl + '/enrollment/getCountsFormEmployer/' + empid)
            .then(response =>{
                console.log(response);
                if(response.data.code === 200){
                    this.setState({
                        countData : response.data.response,
                    })
                }
            })
    }

    formatPhoneNumber = (phoneNumberString) => {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          var intlCode = (match[1] ? '+1 ' : '');
          return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return null;
      }


      captureEvents = async (agentId, email, eventState) => {
        try {
          let data = {
            agentId: agentId,
            eventState: eventState,
            createdBy: String(email).toLowerCase(),
          };
          let apiPath = process.env.REACT_APP_BASE_ROOT_URL + `/agency/api/v1/agent-event`;
          const response = await axios.post(apiPath, data);
          const responseData = response.data;
          return responseData;
        } catch (error) {
          console.error("API call failed", error);
        }
      };

    handleOption = async (option) => {
        this.setState({
            loaderShow : true
        });
        if(option === "Sign Out"){
            await this.captureEvents(this.props.agentId, sessionStorage.getItem("email"), "LOGOUT")
            Auth.signOut();
            localStorage.clear();
            sessionStorage.clear();
            localStorage.setItem('isLogged', false);
            sessionStorage.setItem('isLogged', false);
            window.location.href = '/login';
        } else if(option === 'Profile'){
            this.clearData();    
            let email = sessionStorage.getItem('email');
            let url = "";
            if (process.env.REACT_APP_PORTAL == 'employer') url = `${process.env.REACT_APP_BASE_URL}/employer/getEmployerByEmpId/${sessionStorage.getItem("loggedInEmpId")}`
            else url = `${process.env.REACT_APP_BASE_ROOT_URL}/agency/api/v1/agent/${this.props.agentId}`
            axios.get(url)
                .then(response => {

                    if(response.data.response){
                        let countyCode = '+1';
                        let phone = '';
                        if(response.data.response.phone){
                            if(response.data.response.phone.length === 13){
                                countyCode = response.data.response.phone.substr(0,3);
                                phone = this.formatPhoneNumber(response.data.response.phone.substr(2));
                            } else {
                                countyCode = response.data.response.phone.substr(0,2);
                                phone = this.formatPhoneNumber(response.data.response.phone);
                            }
                        } else {
                            countyCode = this.state.defaultCountryCode;
                            phone = '';
                        }

                        let filePath = response.data.response.image ? response.data.response.image.split('/') : [];
                        let fileName = '';

                        if(filePath.length > 0){
                            fileName = filePath[filePath.length - 1];
                        }

                        if (process.env.REACT_APP_PORTAL == 'employer') {
                            this.setState({
                            fname: response.data.response.firstName,
                            lname: response.data.response.lastName,
                            email: response.data.response.email,
                            phone: phone,
                            desc: response.data.response.description ? response.data.response.description : '',
                            imagePath: response.data.response.image,
                            imageName: fileName,
                            countryCode: countyCode,
                            imageErr: '',
                            loaderShow: false,
                            empProfileModal: true,
                            open: false,
                            anchorEl: null
                        }, () => this.checkValidation());
                        } else {
                        this.setState({
                            id: response.data.response.id,
                            agentId : response.data.response.brokerId,
                            fname : response.data.response.firstName,
                            lname : response.data.response.lastName,
                            email : response.data.response.email,
                            phone : phone,
                            desc : response.data.response.description ? response.data.response.description : '',
                            imagePath : response.data.response.image,
                            imageName : fileName,
                            countryCode : countyCode,
                            imageErr : '',
                            loaderShow : false,
                            profileModal : true,
                            open:false,
                            anchorEl:null
                        }, () => this.checkValidation());
                        }
                    } 
                    else if(response.data.data){
                        let filePath = response.data.data.profileImageRef  ? response.data.data.profileImageRef.split('/') : [];
                        let fileName = '';

                        if(filePath.length > 0){
                            fileName = filePath[filePath.length - 1];
                        }
                        this.setState({
                            id: response.data.data.agentId,
                            agentId : response.data.data.agentId,
                            fname : response.data.data.firstName,
                            lname : response.data.data.lastName,
                            email : response.data.data.email,
                            phone : "+1" + response.data.data.phone,
                            desc : response.data.data.message ? response.data.data.message : '',
                            imagePath : response.data.data.profileImageRef ? response.data.data.profileImageRef : "",
                            imageName : filePath.length > 0 ? fileName : '',
                            countryCode : "+1",
                            imageErr : '',
                            loaderShow : false,
                            profileModal : true,
                            open:false,
                            anchorEl:null,
                            postobj : response.data.data,
                        }, () => this.checkValidation());
                    }
                });
        }
    }

    handleMenuClick = (event) => {       
        this.setState({open:true,anchorEl:event.currentTarget})
      };

    setUserValue = (value, isValid, parentDetails) => {
        if(parentDetails.name === 'email'){
            if(isValid){
                this.state.email = value;
            } else {
                this.state.email = "";
            }
        }else if(parentDetails.name === 'firstname'){
            if(isValid){
                this.state.fname = value.toUpperCase();
            } else {
                this.state.fname = "";
            }
        } else if(parentDetails.name === 'lastname'){
            if(isValid){
                this.state.lname = value.toUpperCase();
            } else {
                this.state.lname = "";
            }
        } else if(parentDetails.name === 'phone'){
            if(isValid){
                this.state.phone = value;
            } else {
                this.state.phone = "";
            }
        } else if(parentDetails.name === 'desc'){
            if(isValid){
                this.state.desc = value;
            } else {
                this.state.desc = "";
            }
        }

        this.setState({
            refresh : true
        }, () => this.checkValidation());

    }

    checkValidation = () => {
        if(this.state.fname !== '' && this.state.lname !== '' &&  this.state.phone !== "" && this.state.email !== "" 
        // && this.state.desc !== ''
        ){
            this.setState({
                agentValid : false
            });
        } else {
            this.setState({
                agentValid : true
            });
        }
    }

    handleFileChange = (event) =>{
        if(event.currentTarget.files.length > 0) {
            const file = event.target.files[0];
            const validFormats = ['image/png', 'image/jpg', 'image/jpeg'];
            const maxSize = 5 * 1024 * 1024; // 5MB

            // Validate file format
            if (!validFormats.includes(file.type)) {
                this.setState({
                    imageErr: 'Invalid format. Supported formats: PNG, JPG, JPEG',
                });
                event.target.value = null;
                return;
            }

            // Validate file size
            if (file.size > maxSize) {
                this.setState({
                    imageErr: 'File size cannot exceed 5MB',
                });
                event.target.value = null;
                return;
            }

            // Read file and show crop modal
            const reader = new FileReader();
            reader.onload = (e) => {
                this.setState({
                    imageSrc: e.target.result,
                    cropModal: true,
                    selectedFile: file,
                    imageErr: '',
                });
            };
            reader.readAsDataURL(file);
            event.target.value = null;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.cropModal && !prevState.cropModal && this.state.imageSrc) {
            this.initializeCropBox();
        }
    }

    initializeCropBox = () => {
        setTimeout(() => {
            const img = document.getElementById('cropImage');
            if (img && img.complete) {
                const containerWidth = img.clientWidth;
                const containerHeight = img.clientHeight;
                const size = Math.min(containerWidth, containerHeight) * 0.7;
                this.setState({
                    cropBox: {
                        x: (containerWidth - size) / 2,
                        y: (containerHeight - size) / 2,
                        width: size,
                        height: size
                    }
                });
            }
        }, 100);
    }

    handleMouseDown = (e, corner = null) => {
        e.stopPropagation();
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const { cropBox } = this.state;
        
        if (corner) {
            // Resizing from a corner
            this.setState({
                isResizing: true,
                resizeCorner: corner,
                dragStart: { x, y }
            });
        } else if (x >= cropBox.x && x <= cropBox.x + cropBox.width &&
            y >= cropBox.y && y <= cropBox.y + cropBox.height) {
            // Dragging the box
            this.setState({
                isDragging: true,
                dragStart: { x: x - cropBox.x, y: y - cropBox.y }
            });
        }
    }

    handleMouseMove = (e) => {
        if (!this.state.isDragging && !this.state.isResizing) return;
        
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const { dragStart, cropBox, resizeCorner } = this.state;
        
        if (this.state.isResizing) {
            // Handle resizing - maintain square aspect ratio
            let newWidth = cropBox.width;
            let newHeight = cropBox.height;
            let newX = cropBox.x;
            let newY = cropBox.y;
            
            if (resizeCorner === 'se') {
                // Southeast corner
                const deltaX = x - (cropBox.x + cropBox.width);
                const deltaY = y - (cropBox.y + cropBox.height);
                const delta = Math.max(deltaX, deltaY);
                newWidth = Math.max(50, Math.min(cropBox.width + delta, rect.width - cropBox.x, rect.height - cropBox.y));
                newHeight = newWidth;
            } else if (resizeCorner === 'sw') {
                // Southwest corner
                const deltaX = cropBox.x - x;
                const deltaY = y - (cropBox.y + cropBox.height);
                const delta = Math.max(deltaX, deltaY);
                newWidth = Math.max(50, Math.min(cropBox.width + delta, cropBox.x + cropBox.width, rect.height - cropBox.y));
                newHeight = newWidth;
                newX = cropBox.x + cropBox.width - newWidth;
            } else if (resizeCorner === 'ne') {
                // Northeast corner
                const deltaX = x - (cropBox.x + cropBox.width);
                const deltaY = cropBox.y - y;
                const delta = Math.max(deltaX, deltaY);
                newWidth = Math.max(50, Math.min(cropBox.width + delta, rect.width - cropBox.x, cropBox.y + cropBox.height));
                newHeight = newWidth;
                newY = cropBox.y + cropBox.height - newHeight;
            } else if (resizeCorner === 'nw') {
                // Northwest corner
                const deltaX = cropBox.x - x;
                const deltaY = cropBox.y - y;
                const delta = Math.max(deltaX, deltaY);
                newWidth = Math.max(50, Math.min(cropBox.width + delta, cropBox.x + cropBox.width, cropBox.y + cropBox.height));
                newHeight = newWidth;
                newX = cropBox.x + cropBox.width - newWidth;
                newY = cropBox.y + cropBox.height - newHeight;
            }
            
            this.setState({
                cropBox: { x: newX, y: newY, width: newWidth, height: newHeight }
            });
        } else if (this.state.isDragging) {
            // Handle dragging
            let newX = x - dragStart.x;
            let newY = y - dragStart.y;
            
            // Boundary checks
            newX = Math.max(0, Math.min(newX, rect.width - cropBox.width));
            newY = Math.max(0, Math.min(newY, rect.height - cropBox.height));
            
            this.setState({
                cropBox: { ...cropBox, x: newX, y: newY }
            });
        }
    }

    handleMouseUp = () => {
        this.setState({ isDragging: false, isResizing: false, resizeCorner: null });
    }

    getCroppedImage = () => {
        const canvas = document.createElement('canvas');
        const img = document.getElementById('cropImage');
        const ctx = canvas.getContext('2d');
        
        const scaleX = img.naturalWidth / img.clientWidth;
        const scaleY = img.naturalHeight / img.clientHeight;
        
        canvas.width = this.state.cropBox.width * scaleX;
        canvas.height = this.state.cropBox.height * scaleY;
        
        ctx.drawImage(
            img,
            this.state.cropBox.x * scaleX,
            this.state.cropBox.y * scaleY,
            this.state.cropBox.width * scaleX,
            this.state.cropBox.height * scaleY,
            0,
            0,
            canvas.width,
            canvas.height
        );
        
        return new Promise((resolve) => {
            canvas.toBlob((blob) => {
                resolve(blob);
            }, 'image/jpeg', 0.95);
        });
    }

    handleCropSave = async () => {
        try {
            this.setState({ loaderShow: true, cropModal: false });

            const croppedBlob = await this.getCroppedImage();

            if (!croppedBlob) {
                this.setState({ loaderShow: false, imageErr: 'Crop failed. Please try again.' });
                return;
            }

            const croppedFile = new File([croppedBlob], this.state.selectedFile.name, {
                type: 'image/jpeg',
            });

            let bodyFormData = new FormData();
            bodyFormData.append('file', croppedFile);
            this.state.imageName = this.state.selectedFile.name;

            axios(configurations.baseUrl + '/agentlogin/uploadImage', {
                method: 'post',
                data: bodyFormData,
                headers: {'Content-Type': 'multipart/form-data' }
            }).then(response =>{
                if(response.data.code === 200){
                    this.setState({
                        imagePath : response.data.response,
                        loaderShow : false,
                        imageSrc: null,
                        croppedImage: null,
                    },() => this.checkValidation());
                }
            }).catch(error => {
                this.setState({
                    loaderShow: false,
                    imageErr: 'Upload failed. Please try again.',
                });
            });

        } catch (e) {
            console.error(e);
            this.setState({
                loaderShow: false,
                imageErr: 'Processing failed. Please try again.',
            });
        }
    }

    handleCropCancel = () => {
        this.setState({
            cropModal: false,
            imageSrc: null,
            croppedImage: null,
            selectedFile: null,
            cropBox: { x: 50, y: 50, width: 200, height: 200 },
            isDragging: false,
            isResizing: false,
            resizeCorner: null,
        });
    }

    handleRemoveProfilePic = () => {
        this.setState({ imagePath: '', imageName: '' });
    }

    updateAgentAndView=()=>{
        this.updateAgent();
        let data = JSON.parse(sessionStorage.getItem("USER_DATA"))
        let url = configurations.AGENT_BASE_URL + data.clientName + "/"+ this.props.agentId
        if(url !== ''){
         
             document.execCommand("copy",);
            window.open(url, '_blank');
         }
    }

    updateAgent = () =>{
        this.getClientProfile();
        this.setState({
            loaderShow : true
        });
        let newPhone = this.state.phone.replace(/[^a-zA-Z0-9]/g, '');

        let obj = {
            "firstName" : this.state.fname,
            "lastName": this.state.lname,
            "description": this.state.desc,
            "email":this.state.email,
            "phone": this.state.countryCode + newPhone.substr(1),
            image : this.state.imagePath ? this.state.imagePath : ""
        }

        let object = JSON.parse(JSON.stringify(this.state.postobj));
        object.firstName = this.state.fname;
        object.lastName = this.state.lname;
        object.phone = this.state.phone.replaceAll("+1", "").replace(/[^a-zA-Z0-9+]/g, '');
        object.message = this.state.desc || null;
        object.profileImageRef = this.state.imagePath ? this.state.imagePath : "";
        let url= `${process.env.REACT_APP_BASE_ROOT_URL}/agency/api/v1/agent/${this.props.agentId}`;

        axios.put(url, object)
            .then(response => {
                if(response.data){
                    this.setState({  
                        loaderShow : false,
                        profileModal : false    
                    }, () => this.clearData());
                    this.getClientProfile();
                }

            })
    }

    clearData = () =>{
        this.setState({
            fname:'',
            lname:'',
            email:'',
            phone:'',
            countryCode : '',
            desc : '',
            imageName : '',
            imageErr : ''
        });
    }
      
    SwitchClient=(event) =>{
        let channel=this.state.switchArray.filter(result => result.clientName==event);
        localStorage.setItem("channelName", event)
        if(channel.length>0){
        let obj={
            "custom:agentid": this.props.agentId,
            "given_name": "Netwell",
            "custom:associationId": channel[0].associationId,
            "custom:ChannelId": channel[0].clientId,
            "name": channel[0].firstName + " " + channel[0].lastName,
            "family_name": channel[0].lastName,
            "email": localStorage.getItem("email")
        }
        localStorage.setItem("SwitchAccount", JSON.stringify(obj))
        localStorage.setItem("brokerID", channel[0].brokerId)
        window.location.href = '/'
    }else{
        localStorage.removeItem("SwitchAccount")
        localStorage.removeItem("brokerID")
        window.location.href = '/'
    }
    }
    getModeList = (topbarData) => {
        var valuesData = topbarData;
        if(valuesData){
            valuesData.employer = valuesData.emplopyer || null;  
                delete valuesData.emplopyer;
            }
            const transformData = {};
    
            if (valuesData && typeof valuesData === 'object') {
                for (const [label, values] of Object.entries(valuesData)) {
                  transformData[label] = {};
                  if (values && typeof values === 'object') {
                    for (const [key, value] of Object.entries(values)) {
                      transformData[label][key.toUpperCase()] = value;
                    }
                  }
                }
              }
    
            const labelArray = Object.keys(transformData).map(key => ({
             label: "Work with " + key.charAt(0).toUpperCase() + key.slice(1) + "s"
            }));
            return labelArray;
    }

    getClientProfile = () => {
        const url = `${configurations.baseUrl}/agentlogin/getAgentById/`+ sessionStorage.getItem('parentBrokerId');
        axios.get(url)
            .then(response => {
                if (response.data && response.data.response && response.data.response.image) {
                    this.setState({ profileImage: response.data.response.image });
                } else {
                    this.setState({ profileImage: null });
                }
            })
            .catch(error => {
                console.error('Error fetching agent profile:', error);
                this.setState({ profileImage: null });
            });
    }

    render() {
        const params = new URLSearchParams(window.location.search);
        const empid = params.get("empid");

        const labelArray = this.getModeList(this.state.topbarData);
        const options=["Profile","Sign Out"]
        console.log('Current route:', this.props.location.pathname);
        let currentScreen = '';
        this.state.isLogged = sessionStorage.getItem('isLogged');

        if (this.state.isLogged === 'true' || this.state.isLogged === true) {
            currentScreen = <div style={styles.LoginWrp}>
                <div style={styles.HeaderWrp}>
                    <Grid xs={6} style={styles.HeaderRightWrp} item={true}>
                        <span style={styles.LoginRight}>Member Enrollment</span>
                    </Grid>
                    <Grid xs={6} style={styles.HeaderLeftWrp} item={true}>

                        <span style={styles.LoginLeft} onClick={this.logoutHandler}>LOGOUT</span>
                    </Grid>
                </div>
            </div>
        } else {
            currentScreen = <div  >
                     <AppBar title="Agent Portal" position='fixed' style={{backgroundColor:'#fff',marginBottom: this.props.bottomMargin, display : '-webkit-inline-box', zIndex: 100}}>
                         <Toolbar style={{width : '50%', padding : '5px'}}>
                         {(empid && process.env.REACT_APP_PORTAL != 'employer') ? <IconButton color="inherit" aria-label="Menu" style={{marginTop:'6px',marginRight:'6px', cursor : 'pointer'}} onClick={() => {window.location.replace('/manage-employers')}} >
                                     <ArrowBackIcon style={{color: "#8283be"}}/>
                                 </IconButton> : <div style={{paddingRight: 30}}/>}
                                     <img src={require("../../../Assets/Images/UHS_Logo_AgentPortal.png")} height={"50px"}/>
                         </Toolbar>
                         <Toolbar style={{width : '50%'}}>
                             <div className="spacer"/>
                                 {/* {this.state.userName} */}
                               {(process.env.REACT_APP_PORTAL != 'employer') && <Grid container spacing={1} style={{display: "contents"}}>
                                <Grid xs={12} sm={4} style={{paddingRight:10}}>
                                        <FormControl className='select-bar' fullWidth style={{ borderRadius: 4, border: "solid 1px #d5d6e9", backgroundColor: '#f6f9ff !important' }}>
                                            <InputLabel id="demo-simple-select-label" style={{ padding: 6 }}>Mode</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={this.state.mode}
                                                label="Mode"
                                                style={{ paddingLeft: 6, fontWeight: "bold" }}
                                                onChange={(e) => this.getModeSelect(e.target.value)}
                                            >
                                                {this.state.modeList && this.state.modeList.length > 0 && this.state.modeList.map((data) =>
                                                    <MenuItem value={data.label}>{data.label}</MenuItem>
                                                )}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid xs={12} sm={4} style={{marginRight:30}}>
                                        <FormControl className='select-bar' fullWidth style={{ borderRadius: 4, border: "solid 1px #d5d6e9" }}>
                                            <InputLabel id="demo-simple-select-label" style={{ padding: 6 }}>Channel Name</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={this.state.ChannelName}
                                                label="Channel Name"
                                                style={{ paddingLeft: 6, fontWeight: "bold" }}
                                                onChange={(e) => this.SwitchClient(e.target.value)}
                                            >
                                                <MenuItem style={{ fontWeight: "bold" }} value={localStorage.getItem("parentClientName")}>{localStorage.getItem("parentClientName")}</MenuItem>
                                                {this.state.switchArray && this.state.switchArray.length > 0 && this.state.switchArray.map((data) =>
                                                    <MenuItem value={data.clientName}>{data.clientName}</MenuItem>
                                                )}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>}
                                 {this.state.profileImage ? (
                                                <img
                                                     src={this.state.profileImage}
                                                     alt="Profile"
                                                     style={{
                                                          height: '45px',
                                                          width: '45px',
                                                          cursor: 'pointer',
                                                          borderRadius: '50%',
                                                          objectFit: 'cover',
                                                          display: 'block',
                                                          border: '2px solid #e0e0e0',
                                                          background: '#fff',
                                                          margin: '0 8px'
                                                     }}
                                                     onClick={this.handleMenuClick}
                                                />
                                            ) : (
                                                <AccountCircle style={{padding:'0 0.5rem',height:'45px',width:'45px',cursor:'pointer', color: "#8283be"}} onClick={this.handleMenuClick}/>
                                            )}
                                 <Menu keepMounted open={this.state.open} anchorEl={this.state.anchorEl} onClose={this.handleClose}
                                     // style={{left: '85%', top: '-55%'}}
                                       getContentAnchorEl={null}
                                       anchorOrigin={{
                                           vertical: 110,
                                           horizontal: 60,
                                       }}
                                       transformOrigin={{
                                           vertical: 80,
                                           horizontal: "right",
                                       }}>
                                     {options.map((op,i)=>{
                                         return <MenuItem key={i} value={op} onClick={this.handleOption.bind(this, op)}>
                                             {op}
                                         </MenuItem>
                                     })}

                                 </Menu>
                         </Toolbar>
                     </AppBar>
                     
                     {!this.props.hideResource && <div style={{marginTop: this.props.location.pathname === "/" ? 0 : 65, right: this.state.rightBar ? 552: 0}} class="web_orange_tag" onClick={() => this.setState({rightBar:true})}><div class="web_patch_text">Resources</div></div>}
                     <SwipeableDrawer
                            anchor={"right"}
                            open={this.state.rightBar}
                            style={{zIndex: 99}}
                            onClose={() => this.setState({rightBar:false})}
                            onOpen={() => this.setState({rightBar:true})}
                        
                        >
                            <div style={{width: 552, paddingTop: 100, height: "100%", backgroundColor: "#d5d6e9", overflowX: 'hidden'}}>
                               <AccordonCommon 
                               clientId={this.props.clientId} 
                               clientName={this.props.clientName} 
                               agentId={this.props.agentId} 
                               disable={this.props.location.pathname === "/" || this.props.location.pathname === "/manage-employers"} 
                               forHouseholds={this.props.location.pathname === "/manage-prospects"}
                               empid={this.state.empid || ""} 
                               empName={(this.state.countData && this.state.countData.companyName) ? this.state.countData.companyName : ''}
                               />
                            </div>
                    </SwipeableDrawer>
                    
            </div>
        }


        return (
            <div>
                {
                    this.state.loaderShow ? <Loader></Loader> : ''
                }
                {
                    currentScreen
                }

                {/*=================================== Profile Model ======================================*/}
                <Modal size="lg" show={this.state.profileModal} onHide={() => this.setState({profileModal:false, loaderShow : false}, () => this.clearData())} centered backdrop="static">
                    <Modal.Header style={styles.modal_header} closeButton>
                        <Modal.Title>Agent Profile</Modal.Title>
                    </Modal.Header>
                    <Modal.Body  style={{  width : '100%' }}>
                        {
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }
                        
                        <Grid container spacing={2} justify='center'>
                        <Grid item xs={12} sm={5} >
                        <SampleName setChild={this.setUserValue.bind(this)} reqFlag={true} name={'firstname'} label={'First Name'} value={this.state.fname} disable={false} style={customStyle.textFieldWrpAgent} length={25}  fieldType={'fullName'} errMsg={'Enter valid first name'} helperMsg={'First name required'}  parentDetails={{name:'firstname'}}></SampleName>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                        <SampleName setChild={this.setUserValue.bind(this)} reqFlag={true} name={'lastname'} label={'Last Name'} value={this.state.lname} disable={false} style={customStyle.textFieldWrpAgent} length={25}  fieldType={'fullName'} errMsg={'Enter valid last name'} helperMsg={'Last name required'}  parentDetails={{name:'lastname'}}></SampleName>
                        </Grid>
                        <Grid item xs={12} sm={5} >
                        <Sample setChild={this.setUserValue.bind(this)} showHelper={true} reqFlag={true} name={'email'} label={'Email ID'} value={this.state.email} disable={true} style={customStyle.textFieldWrpAgent} length={50}  fieldType={'email'} errMsg={'Enter valid email Id'} helperMsgText={'To change your email address, please contact your agency.'}  parentDetails={{name:'email'}}></Sample>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <div>
                                <MuiPhoneNumber
                                    name={"phone"}
                                    required
                                    id="filled-required"
                                    label={"Mobile No."}
                                    data-cy="user-phone"
                                    variant="filled"
                                    defaultCountry={"us"}
                                    onlyCountries={["us"]}
                                    autoComplete='off'
                                    value={this.state.phone}
                                    length={17}
                                    onChange={(e) => this.setUserValue(e, true, { name: 'phone' })}
                                    disable={false} style={customStyle.textFieldWrpAgent} fieldType={'phone'}
                                    errMsg={'Enter valid mobile no.'} helperMsg={'Mobile no. required'}
                                />
                                {(this.state.phone && this.state.phone.length == 17 || this.state.phone.length === 12) ? null : <p class="MuiFormHelperText-root MuiFormHelperText-contained Mui-required mobileErr">Enter valid mobile no. {this.state.phone.length}</p>}
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={10} >
                        <CommonMultilineText setChild={this.setUserValue.bind(this)} req={false} name={'desc'} label={'Message'} value={this.state.desc} disable={false} style={customStyle.textFieldWrpAgent} length={200}  fieldType={'text'} errMsg={'Enter valid message'} helperMsg={'Message required'}  parentDetails={{name:'desc'}}></CommonMultilineText>
                        </Grid>
                        
                        </Grid>
                        <Grid container spacing={2} style={{marginLeft:'5%'}}>
                        <Grid item xs={12} sm={12} >
                                <input accept="image/png,image/jpg,image/jpeg" style={{display : 'none'}} id="icon-button-file" type="file" onChange={this.handleFileChange.bind(this)} />
                                    <label htmlFor="icon-button-file" style={{fontSize : 'small', color : 'rgba(0, 0, 0, 0.54)'}}>
                                        <IconButton color="primary" aria-label="upload picture" component="span">
                                            <PhotoCamera />
                                        </IconButton>Upload Profile Picture
                                    </label>
                                    <span style={{marginLeft : '5px', fontSize: '12px', color: '#666'}}>Supported: PNG, JPG, JPEG (Max 5MB)</span>
                                    <br/>
                                    <span style={{marginLeft : '5px'}}>{this.state.imageName} </span>
{this.state.imageName && (
    <Tooltip title="Remove profile picture">
        <IconButton
            size="small"
            style={{ color: 'red', marginLeft: 4, verticalAlign: 'middle' }}
            onClick={this.handleRemoveProfilePic}
        >
            <ClearIcon fontSize="small" />
        </IconButton>
    </Tooltip>
)}
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <span style={{ color : '#f44336'}}>{this.state.imageErr} </span>
                        </Grid>
                        </Grid>
                        <hr/>
                        <Grid                        
                        spacing={1}
                        container
                        direction="row"
                        style={{marginLeft:'30%'}}
                        >
                            <Grid item xs={12} sm={2} >
                        
                        <NextButton style={{margin: '0', marginRight : '10px', width: '95px', height: '40px'}} disabled={this.state.agentValid} onClick={() => this.updateAgent()}>UPDATE</NextButton>
                        </Grid>
                        <Grid item xs={12} sm={4} >
                        <NextButton style={{margin: '0', marginRight : '10px', width: '225px', height: '40px'}} disabled={this.state.agentValid} onClick={() => this.updateAgentAndView()} >UPDATE AND VIEW MY PAGE</NextButton>
                        </Grid>
                        <Grid item xs={12} sm={4} >
                        <CustomButton style={{height : '40px'}} onClick={() => this.setState({profileModal:false, loaderShow : false}, () => this.clearData())}>CANCEL</CustomButton>
                        </Grid>
                        </Grid>

                    </Modal.Body>
                </Modal>
                {/*=================================== Profile Model ======================================*/}
                <Modal size="lg" show={this.state.empProfileModal} onHide={() => this.setState({ empProfileModal: false, loaderShow: false }, () => this.clearData())} centered backdrop="static">
                    <Modal.Header style={styles.modal_header} closeButton>
                        <Modal.Title>Employer Profile</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ width: '100%' }}>
                        {
                            this.state.loaderShow ? <Loader></Loader> : ''
                        }

                        <Grid container spacing={2} justify='center'>
                            <Grid item xs={12} sm={5} >
                                <SampleName setChild={this.setUserValue.bind(this)} reqFlag={true} name={'firstname'} label={'First Name'} value={this.state.fname} disable={true} style={customStyle.textFieldWrpAgent} length={25} fieldType={'fullName'} errMsg={'Enter valid first name'} helperMsg={'First name required'} parentDetails={{ name: 'firstname' }}></SampleName>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <SampleName setChild={this.setUserValue.bind(this)} reqFlag={true} name={'lastname'} label={'Last Name'} value={this.state.lname} disable={true} style={customStyle.textFieldWrpAgent} length={25} fieldType={'fullName'} errMsg={'Enter valid last name'} helperMsg={'Last name required'} parentDetails={{ name: 'lastname' }}></SampleName>
                            </Grid>
                            <Grid item xs={12} sm={5} >
                                <Sample setChild={this.setUserValue.bind(this)} reqFlag={true} name={'email'} label={'Email ID'} value={this.state.email} disable={true} style={customStyle.textFieldWrpAgent} length={50} fieldType={'email'} errMsg={'Enter valid email Id'} helperMsg={'Email Id required'} parentDetails={{ name: 'email' }}></Sample>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <div>
                                    <MuiPhoneNumber
                                        name={"phone"}
                                        id="filled-required"
                                        label={"Mobile No."}
                                        data-cy="user-phone"
                                        variant="filled"
                                        defaultCountry={"us"}
                                        onlyCountries={["us"]}
                                        autoComplete='off'
                                        value={this.state.phone}
                                        length={17}
                                        onChange={(e) => this.setUserValue(e, true, { name: 'phone' })}
                                        disabled={true}
                                        required={true}
                                        style={customStyle.textFieldWrpAgent}
                                        fieldType={'phone'}
                                        errMsg={'Enter valid mobile no.'}
                                        helperMsg={'Mobile no. required'}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={10} >
                            </Grid>

                        </Grid>
                        
                        <hr />
                        <Grid
                            spacing={1}
                            container
                            direction="row"
                            style={{ display: 'flex', justifyContent: 'flex-end' }}
                        >
                            <Grid item xs={12} sm={2}>
                                <NextButton style={{ height: '40px', marginTop: 0 }} onClick={() => this.setState({ empProfileModal: false, loaderShow: false }, () => this.clearData())}>CANCEL</NextButton>
                            </Grid>
                        </Grid>

                    </Modal.Body>
                </Modal>

                {/*=================================== Crop Modal ======================================*/}
                <Modal size="lg" show={this.state.cropModal} onHide={this.handleCropCancel} centered backdrop="static">
                    <Modal.Header style={styles.modal_header} closeButton>
                        <Modal.Title>Crop Profile Picture</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ width: '100%' }}>
                        <div style={{ fontSize: '14px', marginBottom: '15px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                            <div><strong>File:</strong> {this.state.selectedFile?.name}</div>
                            <div><strong>Size:</strong> {(this.state.selectedFile?.size / (1024 * 1024)).toFixed(2)} MB</div>
                            <div><strong>Format:</strong> {this.state.selectedFile?.type}</div>
                            <div style={{ marginTop: '8px', color: '#666' }}>
                                <strong>Supported:</strong> PNG, JPG, JPEG | <strong>Max Size:</strong> 5MB
                            </div>
                        </div>
                        <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                            <div style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
                                Drag the crop box to select the area you want and use corners to resize the square shape.
                            </div>
                            {this.state.imageSrc && (
                                <div 
                                    style={{ 
                                        display: 'inline-block', 
                                        position: 'relative', 
                                        maxWidth: '100%',
                                        cursor: this.state.isDragging ? 'grabbing' : 'default'
                                    }}
                                    onMouseDown={this.handleMouseDown}
                                    onMouseMove={this.handleMouseMove}
                                    onMouseUp={this.handleMouseUp}
                                    onMouseLeave={this.handleMouseUp}
                                >
                                    <img 
                                        id="cropImage"
                                        src={this.state.imageSrc} 
                                        alt="Preview" 
                                        style={{ 
                                            maxWidth: '100%', 
                                            maxHeight: '400px',
                                            display: 'block',
                                            border: '2px solid #ddd',
                                            borderRadius: '8px',
                                            userSelect: 'none'
                                        }}
                                        onLoad={this.initializeCropBox}
                                        draggable={false}
                                    />
                                    {/* Crop overlay */}
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        pointerEvents: 'none'
                                    }}>
                                        {/* Dark overlay */}
                                        <div style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: 'rgba(0, 0, 0, 0.5)'
                                        }}></div>
                                        {/* Clear crop area */}
                                        <div style={{
                                            position: 'absolute',
                                            left: this.state.cropBox.x,
                                            top: this.state.cropBox.y,
                                            width: this.state.cropBox.width,
                                            height: this.state.cropBox.height,
                                            border: '2px solid #fff',
                                            boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.5)',
                                            cursor: 'move',
                                            pointerEvents: 'auto'
                                        }}>
                                            {/* Corner resize handles */}
                                            <div 
                                                onMouseDown={(e) => this.handleMouseDown(e, 'nw')}
                                                style={{ 
                                                    position: 'absolute', 
                                                    top: -6, 
                                                    left: -6, 
                                                    width: 12, 
                                                    height: 12, 
                                                    backgroundColor: '#2e3192', 
                                                    border: '2px solid #fff',
                                                    cursor: 'nwse-resize',
                                                    borderRadius: '2px'
                                                }}></div>
                                            <div 
                                                onMouseDown={(e) => this.handleMouseDown(e, 'ne')}
                                                style={{ 
                                                    position: 'absolute', 
                                                    top: -6, 
                                                    right: -6, 
                                                    width: 12, 
                                                    height: 12, 
                                                    backgroundColor: '#2e3192', 
                                                    border: '2px solid #fff',
                                                    cursor: 'nesw-resize',
                                                    borderRadius: '2px'
                                                }}></div>
                                            <div 
                                                onMouseDown={(e) => this.handleMouseDown(e, 'sw')}
                                                style={{ 
                                                    position: 'absolute', 
                                                    bottom: -6, 
                                                    left: -6, 
                                                    width: 12, 
                                                    height: 12, 
                                                    backgroundColor: '#2e3192', 
                                                    border: '2px solid #fff',
                                                    cursor: 'nesw-resize',
                                                    borderRadius: '2px'
                                                }}></div>
                                            <div 
                                                onMouseDown={(e) => this.handleMouseDown(e, 'se')}
                                                style={{ 
                                                    position: 'absolute', 
                                                    bottom: -6, 
                                                    right: -6, 
                                                    width: 12, 
                                                    height: 12, 
                                                    backgroundColor: '#2e3192', 
                                                    border: '2px solid #fff',
                                                    cursor: 'nwse-resize',
                                                    borderRadius: '2px'
                                                }}></div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <NextButton onClick={this.handleCropCancel} style={{ minWidth: '150px' }}>CANCEL</NextButton>
                        <NextButton onClick={this.handleCropSave} style={{ marginLeft: '10px', minWidth: '150px' }}>SAVE & UPLOAD</NextButton>
                    </Modal.Footer>
                </Modal>
            </div>

        )
    }
}

export default withRouter(Header);